var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAudioRecordLightBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 104,
    viewBox: "0 0 104 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9453_3134)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 52,
    cy: 52,
    r: 52,
    fill: "#4D4D4D",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73 50.2C73 60.8848 65.2385 69.7804 55.0833 71.4976V75.4C55.0833 77.3872 53.4816 79 51.5 79C49.5184 79 47.9167 77.3872 47.9167 75.4V71.4976C37.7615 69.7804 30 60.8848 30 50.2C30 48.2128 31.6018 46.6 33.5833 46.6C35.5649 46.6 37.1667 48.2128 37.1667 50.2C37.1667 58.1416 43.5952 64.6 51.5 64.6C59.4048 64.6 65.8333 58.1416 65.8333 50.2C65.8333 48.2128 67.4351 46.6 69.4167 46.6C71.3983 46.6 73 48.2128 73 50.2ZM44.3333 50.2V32.2C44.3333 28.222 47.5404 25 51.5 25C55.4596 25 58.6667 28.222 58.6667 32.2V50.2C58.6667 54.178 55.4596 57.4 51.5 57.4C47.5404 57.4 44.3333 54.178 44.3333 50.2Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9453_3134"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 104,
    height: 104,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudioRecordLightBg);
export default __webpack_public_path__ + "static/media/audio-record-light-bg.d8fb4c0e6fd314dc53886b794408159e.svg";
export { ForwardRef as ReactComponent };